import { render, staticRenderFns } from "./CancelledHealthTable.vue?vue&type=template&id=70d99f3a&"
import script from "./CancelledHealthTable.vue?vue&type=script&lang=js&"
export * from "./CancelledHealthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports